<p-dialog [styleClass]="'popup_import'" [draggable]="false" [resizable]="false" [closable]="false"
    [style]="{'width': '60%'}" [modal]="true" [visible]="show_Dialog">

    <ng-template pTemplate="header">
        <div class="flex wd-100 dialog_header_wrapper align-items-center justify-content-between ng-star-inserted">
            <span class="text-xl font-bold">Edit</span>
            <p-button icon="pi pi-times" (onClick)="hide()"
                styleClass="p-button-rounded p-button-danger p-button-text p-button-raised"></p-button>
        </div>
    </ng-template>

    <div class="col-12 md:col-12 lg:col-12 xl:col-12 p-0 mt-3 mb-3">
        <form [formGroup]="editForm" *ngIf="editForm">
            <div class="grid m-0">
                <div class="col-12 md:col-6 lg:col-6 xl:col-6">
                    <acv-text-input [form]="editForm" [ControlName]="type + '_at'" [ControlLabelText]="'Actual ' + (type == 'complete' ? 'End' : type | titlecase) + ' Date'"
                        [Required]="true" PlaceHolderText="Select Date" [ControlType]="'date'" [ShowWordCount]="false"
                        [IsSubmited]="is_form_submit"></acv-text-input>
                </div>
                <div class="col-12 md:col-6 lg:col-6 xl:col-6">
                    <div class="input-elem">
                        <p class="text-control-label mb-2">
                            Actual {{ type == 'complete' ? 'End' : type | titlecase }} Time <sup>*</sup>
                        </p>
                        <div class="w-full flex gap-3 align-items-center timedd-container">
                            <p>Hours</p>
                            <p-dropdown [options]="hours_arr" [appendTo]="'body'" [formControlName]="type + '_hr'"
                                [filter]="true" optionLabel="name" optionValue="name"></p-dropdown>
                            <p-dropdown [options]="mins_arr" [appendTo]="'body'" [formControlName]="type + '_min'"
                                [filter]="true" optionLabel="name" optionValue="id"></p-dropdown>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>

    <ng-template pTemplate="footer">
        <p-button  type="button" label="Cancel"
            class="p-button-text elevated-btn secondary mr-2" (click)="hide()"></p-button>
        <p-button [disabled]="!editForm.valid" type="button" [label]="'Update'"
            class="p-button-text elevated-btn primary mr-2" (click)="submit()"></p-button>
    </ng-template>

</p-dialog>